import { useContext, useEffect, useState } from 'react';
import { RegistryForm } from '../login/registryForm';
import { apiBasePath } from '../../utils/constants';
import { GlobalContext } from '../../utils/globalContext';
import axios from 'axios';
import { Divider, Flex } from 'antd';
// import { Divider } from 'antd';

const Profile = () => {
  const { user } = useContext(GlobalContext);
  const [profile, setProfile] = useState(user);
  const getProfile = async () => {
    try {
      const response = await axios.get(`${apiBasePath}/customer/id/${user.clie_id}`);
      setProfile(response.data.customer);
    } catch (error) {
      console.error('🚀 ~ getProfile ~ error:', error);
    }
  };
  useEffect(() => {
    getProfile();
  }, []);
  return (
    <div className="basic-layout">
      <Flex justify="space-between" align="center" className="basic-layout-header">
        <h1>Mi Perfil</h1>
      </Flex>
      <Divider />
      <RegistryForm isEdit={true} initialValues={profile} />
    </div>
  );
};

export { Profile };
